let development = process.env.NODE_ENV === 'development';

const config = {}
config.amapKeys = {
    name:"高德地图web服务KEY",
    key:"a81579144e"
};
const text = false;
if(development || text){
    config.baseUrl = "/api1";
    config.imgUploadUrl = "/api1/exam/fileService/upload";
    config.imgUploadUrlFile = "/api1/exam/fileService/uploadFile";
    config.imgUploadUrlTest = "/api1/exam/fileService/test";
}else{
    config.baseUrl = "/api";
    config.imgUploadUrl = "/api/exam/fileService/upload";
    config.imgUploadUrlFile = "/api1/exam/fileService/uploadFile";
    config.imgUploadUrlTest = "/api/exam/fileService/test";
}

export default config;
